module.exports = __webpack_public_path__ + "packs/media/images/Chat-3b36fcafce9b793aa27df391b5db5b9b.svg";